import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { RescheduleModalEl } from '../Elements'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'
import Input from '../../../../../../../../../Components/Input/Input'
import Button from '../../../../../../../../../Components/Buttons/Button'
import date from 'date-and-time'
import { H4 } from '../../../../../../../../../Styles/typography'

function Reschedule({ onSubmit, data }) {
  const [loading, setLoading] = useState(false)

  const { handleSubmit, errors, control } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        date: yup
          .number()
          .required('Day is required')
          .min(
            new Date().setHours(0, 0, 0, 0),
            'The starting date can not be in the past.',
          ),
        time: yup.number().required('Time is required'),
      }),
    ),
    defaultValues: {
      date:
        Number(data?.startTime) ||
        new Date().setHours(new Date().getHours() + 1, 0, 0, 0),
      time:
        Number(data?.startTime) ||
        new Date().setHours(new Date().getHours() + 1, 0, 0, 0),
    },
  })

  return (
    !!data && (
      <RescheduleModalEl>
        <H4>{data?.extraClass ? 'Create a class' : 'Reschedule Class'}</H4>
        <form
          onSubmit={handleSubmit(async (val) => {
            console.log({ val })
            setLoading(true)
            const dt = date.format(new Date(val.date), 'DD MM YYYY')
            const time = date.format(new Date(val.time), 'hh:mm A')
            const startTime = date
              .parse(`${dt} ${time}`, 'DD MM YYYY hh:mm A')
              .getTime()

            const subData = {
              startTime: startTime,
              extraClass: data?.extraClass,
              classId: data?.id,
            }

            await onSubmit(subData)
          })}
        >
          <Controller
            as={
              <Input
                type='datepicker'
                mode='date'
                field={{ name: 'date' }}
                form={{ touched: { date: true }, errors }}
                error={errors?.date?.message}
              />
            }
            control={control}
            name='date'
            placeholder='Date'
            minDate={new Date()}
            error={errors?.date?.message}
          />
          <Controller
            as={
              <Input
                type='datepicker'
                coarseMinutes={30}
                forceCoarseMinutes
                field={{ name: 'time' }}
                form={{ touched: { time: true }, errors }}
                error={errors?.time?.message}
              />
            }
            control={control}
            name='time'
            showTimePlaceholder={true}
            placeholder='Time'
            error={errors?.time?.message}
          />
          <Button
            name='Submit'
            type='submit'
            onClick={() => {}}
            disabled={loading}
            loading={loading}
          />
        </form>
      </RescheduleModalEl>
    )
  )
}

export default Reschedule
